export default {
    "formats": [
        'pdf',
    ],
    "relations": {
        'pdf': 'pdf',
    }
}


// WEBPACK FOOTER //
// ./src/validator/docsformatpdf.js